import React from "react";

interface TableInputProps {
  value: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}

function TableInput({
  value,
  onChange,
  type = "text",
  placeholder = "",
  disabled = false,
  readOnly = false,
  onClick,
  style,
}: TableInputProps) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
      placeholder={placeholder}
      onClick={onClick}
      style={{
        width: "100%",
        height: "100%",
        border: "1px solid #d0d7de",
        outline: "none",
        padding: "4px 8px",
        ...style,
        margin: 0,
        fontSize: "13px",
        fontWeight: "500",
        textAlign: "center",
        background: "#f6f8fa",
        color: "#24292f",
        borderRadius: "6px",
        boxSizing: "border-box",
        transition: "all 0.15s ease",
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = "#0969da";
        e.currentTarget.style.boxShadow = "0 0 0 3px rgba(9, 105, 218, 0.1)";
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = "#d0d7de";
        e.currentTarget.style.boxShadow = "none";
      }}
      onMouseEnter={(e) => {
        if (!disabled && !readOnly) {
          e.currentTarget.style.background = "#eaeef2";
          e.currentTarget.style.borderColor = "#0969da";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !readOnly && document.activeElement !== e.currentTarget) {
          e.currentTarget.style.background = "#f6f8fa";
          e.currentTarget.style.borderColor = "#d0d7de";
        }
      }}
    />
  );
}

export default TableInput;
